import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="nuuma-container py-24 md:py-32">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-nuuma-primary hover:text-nuuma-secondary transition-colors mb-6 group"
        >
          <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
          Powrót do strony głównej
        </Link>
        <h1 className="text-3xl md:text-4xl font-display font-bold text-nuuma-primary mb-6">
          Polityka Prywatności
        </h1>
        
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-nuuma-grey200 pb-6 mb-8">
          <div>
            <p className="text-nuuma-grey700 text-sm">
              Serwis internetowy: <strong>nuumagenetics.pl</strong>
            </p>
            <p className="text-nuuma-grey600 text-xs mt-1">
              Status dokumentu: Zgodny z Ogólnym Rozporządzeniem o Ochronie Danych (RODO)
            </p>
          </div>
          <a
            href="/Polityka_Prywatnosci_nuumagenetics.pdf"
            download
            className="inline-flex items-center gap-2 text-sm font-semibold text-nuuma-secondary hover:text-nuuma-secondary/80 transition-colors shrink-0 bg-nuuma-secondary/5 px-4 py-2 rounded-nuuma-s border border-nuuma-secondary/20"
          >
            Pobierz PDF
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </a>
        </div>

        {/* Highlight Box */}
        <div className="bg-nuuma-grey100 rounded-nuuma-m p-6 mb-8 text-sm text-nuuma-grey800 space-y-2 border border-nuuma-grey200">
          <p><strong>Administrator Danych:</strong> CITOLAB LABORATORIO CITODIAGNÓSTICO, S.L. (Hiszpania)</p>
          <p><strong>Kontakt w sprawach prywatności:</strong> <a href="mailto:info@nuumagenetics.pl" className="text-nuuma-secondary hover:underline">info@nuumagenetics.pl</a></p>
        </div>

        <div className="space-y-8 text-nuuma-grey800 leading-relaxed text-sm md:text-base">
          <p>
            Niniejsza Polityka prywatności określa zasady gromadzenia, przetwarzania i ochrony danych osobowych Użytkowników korzystających z serwisu internetowego <strong>nuumagenetics.pl</strong> (dalej jako „Serwis”). Administrator dokłada wszelkich starań, aby zapewnić poszanowanie prywatności oraz ochronę informacji osobowych i medycznych dostarczanych przez Użytkowników podczas korzystania z Serwisu oraz zamawiania oferowanych usług diagnostycznych i genetycznych.
          </p>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              1. DEFINICJE
            </h2>
            <ul className="space-y-3 list-none pl-0">
              <li>
                <strong>Administrator</strong> — podmiot odpowiedzialny za przetwarzanie danych osobowych Użytkowników Serwisu: <strong>CITOLAB LABORATORIO CITODIAGNÓSTICO, S.L.</strong> z siedzibą pod adresem: Avda. de Dénia, 76 – 03016 Alicante, Hiszpania, posiadający numer identyfikacji podatkowej (CIF): B-53238026.
              </li>
              <li>
                <strong>Dane osobowe</strong> — wszelkie informacje o zidentyfikowanej lub możliwej do zidentyfikowania osobie fizycznej („osobie, której dane dotyczą”). Możliwa do zidentyfikowania osoba fizyczna to osoba, którą można bezpośrednio lub pośrednio zidentyfikować, w szczególności na podstawie identyfikatora takiego jak imię i nazwisko, numer identyfikacyjny, dane o lokalizacji, identyfikator internetowy lub jeden bądź kilka szczególnych czynników określających fizyczną, fizjologiczną, genetyczną, psychiczną, ekonomiczną, kulturową lub społeczną tożsamość osoby fizycznej.
              </li>
              <li>
                <strong>Dane szczególnej kategorii (w tym dane genetyczne i medyczne)</strong> — dane osobowe podlegające szczególnej ochronie, o których mowa w art. 9 ust. 1 RODO. Dotyczą one informacji o stanie zdrowia, wywiadzie medycznym, a także danych genetycznych uzyskanych w wyniku laboratoryjnej analizy próbek biologicznych dostarczonych przez Użytkownika w celu realizacji zamówionych testów DNA.
              </li>
              <li>
                <strong>Serwis</strong> — serwis internetowy prowadzony przez Administratora pod adresem internetowym: <strong>nuumagenetics.pl</strong>.
              </li>
              <li>
                <strong>Użytkownik</strong> — każda osoba fizyczna odwiedzająca Serwis lub korzystająca z jednej bądź kilku usług czy funkcjonalności opisanych w niniejszej Polityce prywatności.
              </li>
              <li>
                <strong>RODO</strong> — Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych).
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              2. PRZETWARZANIE DANYCH W ZWIĄZKU Z KORZYSTANIEM Z SERWISU
            </h2>
            <p>
              W związku z korzystaniem przez Użytkownika z Serwisu, Administrator zbiera dane w zakresie niezbędnym do świadczenia poszczególnych oferowanych usług, a także informacje o aktywności Użytkownika w Serwisie, w tym pliki cookies i identyfikatory urządzeń. Szczegółowe zasady, cele oraz podstawy prawne przetwarzania danych osobowych opisano w kolejnych punktach niniejszego dokumentu.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              3. CELE ORAZ PODSTAWY PRAWNE PRZETWARZANIA DANYCH OSOBOWYCH
            </h2>
            
            <div className="space-y-4 pl-2">
              <h3 className="text-lg font-bold text-nuuma-primary mt-4">
                3.1. Korzystanie z Serwisu nuumagenetics.pl
              </h3>
              <p>
                Dane osobowe wszystkich osób korzystających z Serwisu (w tym adres IP, identyfikatory internetowe oraz informacje gromadzone za pośrednictwem plików cookies czy innych podobnych technologii) są przetwarzane przez Administratora:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  <strong>w celu świadczenia usług drogą elektroniczną</strong> w zakresie udostępniania Użytkownikom treści gromadzonych w Serwisie oraz udostępniania formularzy kontaktowych — wówczas podstawą prawną przetwarzania jest niezbędność przetwarzania do wykonania umowy o świadczenie usługi drogą elektroniczną (<strong>art. 6 ust. 1 lit. b RODO</strong>);
                </li>
                <li>
                  <strong>w celach analitycznych i statystycznych</strong> — wówczas podstawą prawną przetwarzania jest prawnie uzasadniony interes Administratora (<strong>art. 6 ust. 1 lit. f RODO</strong>), polegający na prowadzeniu analiz aktywności Użytkowników, a także ich preferencji w celu optymalizacji funkcjonalności Serwisu i poprawy jakości świadczonych usług.
                </li>
              </ul>

              <h3 className="text-lg font-bold text-nuuma-primary mt-6">
                3.2. Składanie zamówień i realizacja testów DNA
              </h3>
              <p>
                Złożenie zamówienia na zakup badania genetycznego lub innej usługi diagnostycznej wiąże się z przetwarzaniem Danych Osobowych Użytkownika (oraz ewentualnie pacjenta, jeśli badanie zamawiane jest w czyimś imieniu). Podanie danych oznaczonych jako obowiązkowe jest wymagane w celu przyjęcia i obsługi zamówienia, a ich niepodanie skutkuje brakiem możliwości jego realizacji. Dane te są przetwarzane:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  <strong>w celu realizacji zamówienia</strong>, w tym wysyłki zestawu pobraniowego, rejestracji próbki biologicznej, przeprowadzenia analizy laboratoryjnej oraz wygenerowania i udostępnienia wyniku badania — podstawą prawną przetwarzania danych zwykłych (identyfikacyjnych, kontaktowych, adresowych) jest niezbędność do wykonania umowy (<strong>art. 6 ust. 1 lit. b RODO</strong>);
                </li>
                <li>
                  <strong>w zakresie danych szczególnej kategorii</strong> (dane genetyczne uzyskane z próbek biologicznych, wywiad zdrowotny, dane medyczne) — podstawą prawną ich przetwarzania jest wyraźna, świadoma i dobrowolna zgoda Użytkownika (<strong>art. 9 ust. 2 lit. a RODO</strong>) lub konieczność profilaktyki zdrowotnej, diagnozy medycznej i zapewnienia opieki zdrowotnej na podstawie właściwych przepisów prawa (<strong>art. 9 ust. 2 lit. h RODO</strong>);
                </li>
                <li>
                  <strong>w celu realizacji obowiązków prawnych i finansowo-podatkowych</strong> ciążących na Administratorze, wynikających z przepisów prawa podatkowego oraz rachunkowości — podstawą prawną jest wypełnienie obowiązku prawnego (<strong>art. 6 ust. 1 lit. c RODO</strong>);
                </li>
                <li>
                  <strong>w celu ustalenia, dochodzenia lub obrony przed ewentualnymi roszczeniami prawnymi</strong> związanymi z zawartą umową — podstawą prawną jest prawnie uzasadniony interes Administratora (<strong>art. 6 ust. 1 lit. f RODO</strong>), polegający na ochronie praw i interesów przedsiębiorstwa.
                </li>
              </ul>
              
              <div className="bg-nuuma-secondary/5 border-l-4 border-nuuma-secondary p-4 rounded-r-nuuma-s text-sm mt-3">
                <strong>Ważna informacja o danych genetycznych:</strong> Przetwarzanie próbek biologicznych (np. śliny, wymazów) oraz wyodrębnionych z nich danych genetycznych odbywa się z zachowaniem najwyższych standardów bezpieczeństwa laboratoryjnego i informatycznego. Dane te są wykorzystywane wyłącznie w celu wykonania zamówionego przez Państwa badania i nie są używane do żadnych innych celów bez Państwa odrębnej, wyraźnej zgody.
              </div>

              <h3 className="text-lg font-bold text-nuuma-primary mt-6">
                3.3. Formularze kontaktowe i korespondencja e-mail
              </h3>
              <p>
                W przypadku skontaktowania się z Administratorem za pomocą poczty elektronicznej (info@nuumagenetics.pl) lub formularzy kontaktowych w Serwisie, Dane Osobowe Użytkownika są przetwarzane w celu obsługi przesłanego zapytania, prowadzenia korespondencji oraz rozwiązania zgłoszonej sprawy. Podstawą prawną przetwarzania jest prawnie uzasadniony interes Administratora (<strong>art. 6 ust. 1 lit. f RODO</strong>), polegający na sprawnej komunikacji z użytkownikami, klientami oraz potencjalnymi kontrahentami.
              </p>

              <h3 className="text-lg font-bold text-nuuma-primary mt-6">
                3.4. Działania marketingowe
              </h3>
              <p>
                Administrator może przetwarzać dane osobowe Użytkowników w celach marketingowych, które obejmują m.in. promowanie oferty własnej. W przypadku kierowania informacji marketingowych drogą elektroniczną (np. newsletter, e-mail), podstawą prawną jest prawnie uzasadniony interes Administratora (<strong>art. 6 ust. 1 lit. f RODO</strong>) w połączeniu z dobrowolnie wyrażoną zgodą Użytkownika na otrzymywanie informacji handlowych zgodnie z przepisami o świadczeniu usług drogą elektroniczną.
              </p>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              4. OKRES PRZECHOWYWANIA DANYCH OSOBOWYCH
            </h2>
            <p>
              Okres przetwarzania danych przez Administratora zależy od rodzaju świadczonej usługi oraz celu przetwarzania:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>Dane związane z realizacją zamówień i umów:</strong> są przechowywane przez czas niezbędny do wykonania umowy, a następnie do momentu upływu okresu przedawnienia roszczeń cywilnoprawnych wynikających z umowy oraz okresu obowiązkowego przechowywania dokumentacji księgowej i podatkowej (wynoszącego w większości przypadków 5 lat od końca roku kalendarzowego, w którym upłynął termin płatności podatku).
              </li>
              <li>
                <strong>Dokumentacja medyczna i wyniki analiz genetycznych:</strong> są przechowywane przez okresy wymagane przez powszechnie obowiązujące przepisy prawa dotyczące placówek medycznych i laboratoriów diagnostycznych (co do zasady do 20 lat, o ile przepisy szczególne nie stanowią inaczej).
              </li>
              <li>
                <strong>Dane przetwarzane na podstawie zgody:</strong> są przetwarzane do momentu wycofania tej zgody przez Użytkownika, co nie wpływa na zgodność z prawem przetwarzania dokonanego przed jej wycofaniem.
              </li>
              <li>
                <strong>Dane przetwarzane w ramach uzasadnionego interesu:</strong> są przechowywane przez okres istnienia tego interesu lub do momentu zgłoszenia przez Użytkownika skutecznego sprzeciwu wobec takiego przetwarzania.
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              5. PLIKI COOKIES I PODOBNE TECHNOLOGIE
            </h2>
            <p>
              Serwis nuumagenetics.pl wykorzystuje pliki cookies (tzw. „ciasteczka”), czyli małe pliki tekstowe zapisywane na urządzeniu końcowym Użytkownika (komputerze, tablecie, smartfonie) podczas przeglądania stron internetowych. Pliki te pozwalają m.in. na rozpoznanie urządzenia i odpowiednie dostosowanie wyglądu oraz działania Serwisu.
            </p>
            <p>
              Administrator stosuje dwa zasadnicze typy plików cookies:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>Cookies sesyjne:</strong> pliki tymczasowe, które są przechowywane na urządzeniu Użytkownika do czasu wylogowania, opuszczenia Serwisu lub wyłączenia przeglądarki internetowej.
              </li>
              <li>
                <strong>Cookies trwałe:</strong> pliki, które pozostają na urządzeniu Użytkownika przez czas określony w parametrach samych plików cookies lub do momentu ich ręcznego usunięcia przez Użytkownika.
              </li>
            </ul>
            <p>
              Pliki cookies są wykorzystywane w celu zapewnienia stabilnego i bezpiecznego działania funkcjonalności Serwisu, zapamiętywania preferencji (np. języka lub zawartości koszyka zamówień) oraz w celach analityczno-statystycznych (np. gromadzenie anonimowych danych o ruchu w Serwisie za pomocą narzędzi takich jak Google Analytics).
            </p>
            <p>
              Użytkownik ma możliwość w każdej chwili zmienić ustawienia dotyczące plików cookies w swojej przeglądarce internetowej, w tym całkowicie zablokować ich zapisywanie lub zażądać powiadomienia o każdym ich umieszczeniu. Ograniczenie stosowania plików cookies może jednak wpłynąć na poprawność działania niektórych modułów i formularzy w Serwisie.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              6. PRAWA UŻYTKOWNIKA (OSOBY, KTÓREJ DANE DOTYCZĄ)
            </h2>
            <p>
              Każdemu Użytkownikowi, w zakresie wynikającym z przepisów RODO, przysługują następujące prawa:
            </p>
            <ol className="list-decimal pl-5 space-y-2">
              <li>
                <strong>Prawo dostępu do danych:</strong> prawo do uzyskania od Administratora potwierdzenia, czy przetwarzane są jego dane osobowe, a jeśli tak, do uzyskania dostępu do nich oraz informacji o celach, kategoriach i odbiorcach danych, a także otrzymania ich kopii (art. 15 RODO).
              </li>
              <li>
                <strong>Prawo do sprostowania danych:</strong> prawo do żądania niezwłocznego sprostowania nieprawidłowych lub uzupełnienia niekompletnych danych osobowych (art. 16 RODO).
              </li>
              <li>
                <strong>Prawo do usunięcia danych („prawo do bycia zapomnianym”):</strong> prawo do żądania usunięcia danych w przypadkach określonych w art. 17 RODO (np. gdy dane nie są już niezbędne do celów, w których zostały zebrane). <em>Uwaga: Prawo to może podlegać ograniczeniom w zakresie, w jakim przetwarzanie jest niezbędne do wywiązania się z prawnego obowiązku przechowywania dokumentacji medycznej lub podatkowej.</em>
              </li>
              <li>
                <strong>Prawo do ograniczenia przetwarzania:</strong> prawo do żądania ograniczenia operacji na danych w przypadkach wskazanych w art. 18 RODO (np. na czas weryfikacji prawidłowości danych).
              </li>
              <li>
                <strong>Prawo do przenoszenia danych:</strong> prawo do otrzymania swoich danych w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego oraz przesłania ich innemu administratorowi (art. 20 RODO).
              </li>
              <li>
                <strong>Prawo do sprzeciwu:</strong> prawo do wniesienia sprzeciwu wobec przetwarzania danych opartego na prawnie uzasadnionym interesie Administratora lub na potrzeby marketingu bezpośredniego (art. 21 RODO).
              </li>
              <li>
                <strong>Prawo do wycofania zgody:</strong> w przypadku, gdy dane są przetwarzane na podstawie zgody (w tym zgody na analizę próbek biologicznych), Użytkownik ma prawo do jej wycofania w dowolnym momencie. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano przed jej wycofaniem.
              </li>
            </ol>
            <p>
              W celu realizacji powyższych uprawnień należy skontaktować się z Administratorem, wysyłając wiadomość na adres e-mail: <a href="mailto:info@nuumagenetics.pl" className="text-nuuma-secondary hover:underline">info@nuumagenetics.pl</a>.
            </p>
            <p>
              Użytkownik ma również prawo wniesienia skargi do organu nadzorczego:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <strong>Polskiego organu nadzorczego:</strong> Prezes Urzędu Ochrony Danych Osobowych (UODO), ul. Stawki 2, 00-193 Warszawa, Polska.
              </li>
              <li>
                <strong>Hiszpańskiego organu nadzorczego:</strong> Agencia Española de Protección de Datos (AEPD), C/ Jorge Juan, 6, 28001-Madrid, Hiszpania.
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              7. ODBIORCY DANYCH OSOBOWYCH
            </h2>
            <p>
              W celu prawidłowego funkcjonowania Serwisu oraz należytej realizacji umów, Administrator korzysta z usług podmiotów zewnętrznych. Dane osobowe Użytkowników mogą być przekazywane następującym kategoriom odbiorców:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                podmiotom świadczącym usługi IT, hostingowe oraz zapewniającym wsparcie techniczne dla systemów informatycznych Serwisu;
              </li>
              <li>
                operatorom pocztowym oraz firmom kurierskim (w celu dostarczania paczek z zestawami pobraniowymi oraz wymiany korespondencji);
              </li>
              <li>
                podmiotom świadczącym usługi księgowe, rachunkowe, doradcze oraz prawne na rzecz Administratora;
              </li>
              <li>
                wyspecjalizowanym zewnętrznym laboratoriom medycznym i diagnostycznym, współpracującym z Administratorem w zakresie bezpośredniej analizy nadesłanych próbek biologicznych, o ile jest to niezbędne do wykonania danej usługi genetycznej;
              </li>
              <li>
                operatorom systemów płatności internetowych (w przypadku wyboru elektronicznej formy płatności za zamówienie).
              </li>
            </ul>
            <p>
              Przekazywanie danych odbywa się wyłącznie na podstawie zawartych umów powierzenia przetwarzania danych osobowych (lub innych ważnych instrumentów prawnych), które zobowiązują odbiorców do zachowania poufności oraz wdrożenia adekwatnych technicznych i organizacyjnych środków bezpieczeństwa chroniących dane.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              8. PRZEKAZYWANIE DANYCH POZA EUROPEJSKI OBSZAR GOSPODARCZY (EOG)
            </h2>
            <p>
              Administrator posiada główną siedzibę w Królestwie Hiszpanii, które jest państwem członkowskim Unii Europejskiej. W związku z tym, przepływ danych osobowych pomiędzy Polską a Hiszpanią odbywa się wewnątrz Europejskiego Obszaru Gospodarczego (EOG) i w pełni podlega jednolitym standardom ochrony wyznaczonym przez RODO.
            </p>
            <p>
              Co do zasady, Administrator nie przekazuje danych osobowych do państw trzecich (poza EOG). W wyjątkowych przypadkach, związanych z wykorzystywaniem w Serwisie globalnych narzędzi analitycznych, statystycznych bądź reklamowych dostarczanych przez podmioty takie jak Google LLC czy Meta Platforms, niektóre dane (np. adres IP, identyfikator pliku cookie) mogą trafiać do serwerów zlokalizowanych poza EOG (w tym do USA). W takich sytuacjach transfer danych opiera się na odpowiednich zabezpieczeniach prawnych zatwierdzonych przez Komisję Europejską, w szczególności na decyzjach stwierdzających odpowiedni stopień ochrony (np. program EU-US Data Privacy Framework) lub na Standardowych Klauzulach Umownych (SCC).
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              9. BEZPIECZEŃSTWO DANYCH OSOBOWYCH
            </h2>
            <p>
              Administrator stosuje środki techniczne i organizacyjne zapewniające ochronę przetwarzanych Danych Osobowych odpowiednią do zagrożeń oraz kategorii danych podlegających ochronie, a w szczególności zabezpiecza dane przed ich udostępnieniem osobom nieuprawnionym, zabraniem przez osobę nieuprawnioną, przetwarzaniem z naruszeniem obowiązujących przepisów oraz zmianą, utratą, uszkodzeniem lub zniszczeniem.
            </p>
            <p>
              Do najważniejszych środków ochrony zalicza się:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                szyfrowanie połączenia z Serwisem przy użyciu certyfikatu SSL (Secure Sockets Layer), co zapewnia poufność danych przesyłanych przez formularze internetowe;
              </li>
              <li>
                restrykcyjną kontrolę dostępu fizycznego i systemowego do miejsc oraz serwerów, w których przetwarzane są dane;
              </li>
              <li>
                nadawanie uprawnień do przetwarzania danych wyłącznie zaufanym pracownikom i współpracownikom Administratora, którzy zostali przeszkoleni z zakresu ochrony danych osobowych i zobowiązali się do zachowania bezwzględnej tajemnicy;
              </li>
              <li>
                regularne testowanie, mierzenie i ocenianie skuteczności stosowanych środków bezpieczeństwa w celu ciągłego doskonalenia ochrony.
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              10. DANE KONTAKTOWE
            </h2>
            <p>
              We wszelkich sprawach związanych z ochroną prywatności, przetwarzaniem danych osobowych, a także w celu realizacji uprawnień wynikających z RODO, mogą Państwo skontaktować się z Administratorem w następujący sposób:
            </p>
            <div className="bg-nuuma-grey100 border border-nuuma-grey200 rounded-nuuma-m p-6 space-y-2">
              <p><strong>Adres e-mail:</strong> <a href="mailto:info@nuumagenetics.pl" className="text-nuuma-secondary hover:underline">info@nuumagenetics.pl</a></p>
              <p><strong>Adres korespondencyjny:</strong></p>
              <p className="pl-4 text-nuuma-grey800">
                CITOLAB LABORATORIO CITODIAGNÓSTICO, S.L.<br />
                Avda. de Dénia, 76<br />
                03016 Alicante<br />
                España (Hiszpania)
              </p>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-display font-bold text-nuuma-primary border-l-4 border-nuuma-secondary pl-3">
              11. ZMIANY POLITYKI PRYWATNOŚCI
            </h2>
            <p>
              Niniejsza Polityka prywatności jest regularnie weryfikowana i aktualizowana w celu zapewnienia jej pełnej zgodności ze zmianami przepisów prawa oraz rozwoju technologii informatycznych Serwisu. Wszelkie zmiany będą publikowane bezpośrednio na tej stronie wraz z podaniem daty ostatniej aktualizacji.
            </p>
            <p className="text-sm text-nuuma-grey600 italic">
              Data ostatniej modyfikacji dokumentu: 10 czerwca 2026 r.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
